module.exports = "td.image-cell {\n  padding: 0.35em 0.5em; }\n  td.image-cell div.image-cell-container {\n    padding: 0;\n    width: 4em !important; }\n  td.image-cell + td {\n    padding-left: 0.5em; }\n  .max-length-30 {\n  width: 30ch;\n  max-width: 30ch;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: inline-block;\n  overflow-x: hidden; }\n  td, th {\n  vertical-align: middle; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/features/market/components/tables/market-table-row.component.scss
// module id = ./src/app/features/market/components/tables/market-table-row.component.scss
// module chunks = main